import React from 'react';

const FAQ = () => {
  return (
    <section className="w-full bg-surface-dark border-t border-border-dark" id="faq">
      <div className="max-w-[800px] mx-auto px-4 py-20 md:px-10">
        <h2 className="text-white text-3xl font-bold text-center mb-12">Common Questions</h2>
        <div className="flex flex-col gap-4">
          <details className="group bg-background-dark border border-border-dark rounded-xl open:border-primary/50 transition-colors">
            <summary className="flex justify-between items-center p-6 cursor-pointer list-none text-white font-medium">
              How does UPI Trackr get my transactions?
              <svg className="w-6 h-6 transition-transform group-open:rotate-180" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </summary>
            <div className="px-6 pb-6 text-text-muted text-sm leading-relaxed">
              You upload your UPI transaction statement PDFs from your payment apps. We process them locally on your device, extracting transaction data without sending anything to our servers.
            </div>
          </details>
          <details className="group bg-background-dark border border-border-dark rounded-xl open:border-primary/50 transition-colors">
            <summary className="flex justify-between items-center p-6 cursor-pointer list-none text-white font-medium">
              Do I need to connect my bank account?
              <svg className="w-6 h-6 transition-transform group-open:rotate-180" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </summary>
            <div className="px-6 pb-6 text-text-muted text-sm leading-relaxed">
              No. UPI Trackr never connects to your bank account. You simply upload PDF statements from your UPI apps and we analyze them offline.
            </div>
          </details>
          <details className="group bg-background-dark border border-border-dark rounded-xl open:border-primary/50 transition-colors">
            <summary className="flex justify-between items-center p-6 cursor-pointer list-none text-white font-medium">
              Which UPI apps are supported?
              <svg className="w-6 h-6 transition-transform group-open:rotate-180" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </summary>
            <div className="px-6 pb-6 text-text-muted text-sm leading-relaxed">
              UPI Trackr supports statements from all major UPI apps including Google Pay, PhonePe, Paytm, BHIM, and bank UPI apps.
            </div>
          </details>
          <details className="group bg-background-dark border border-border-dark rounded-xl open:border-primary/50 transition-colors">
            <summary className="flex justify-between items-center p-6 cursor-pointer list-none text-white font-medium">
              Is my data really safe?
              <svg className="w-6 h-6 transition-transform group-open:rotate-180" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </summary>
            <div className="px-6 pb-6 text-text-muted text-sm leading-relaxed">
              Yes. All processing happens locally on your device. Your financial data never leaves your computer. Optionally, you can encrypt and backup to your private Google Drive.
            </div>
          </details>
          <details className="group bg-background-dark border border-border-dark rounded-xl open:border-primary/50 transition-colors">
            <summary className="flex justify-between items-center p-6 cursor-pointer list-none text-white font-medium">
              Can I export statements?
              <svg className="w-6 h-6 transition-transform group-open:rotate-180" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </summary>
            <div className="px-6 pb-6 text-text-muted text-sm leading-relaxed">
              Yes! You can export your consolidated transaction history and spending reports as CSV, Excel, or PDF for tax filing or record-keeping.
            </div>
          </details>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
